import {
  faCheckCircle,
  faCircleInfo,
  faTriangleExclamation,
} from '@awesome.me/kit-8a9525ab71/icons/classic/light';
import { faLightRectangleHistoryWarning } from '@awesome.me/kit-8a9525ab71/icons/kit/custom';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export type ToastVariant = 'error' | 'success' | 'info' | 'warning';

interface ToastVariantConfig {
  icon: IconDefinition;
  styles: string;
  color: string;
}

export const TOAST_VARIANTS: Record<ToastVariant, ToastVariantConfig> = {
  error: {
    icon: faLightRectangleHistoryWarning,
    styles: 'border-burgundy-lighten-30 bg-burgundy-lighten-80',
    color: 'text-burgundy-darken-50',
  },
  success: {
    icon: faCheckCircle,
    styles: 'border-green-lighten-15 bg-green-lighten-75',
    color: 'text-green-darken-40',
  },
  info: {
    icon: faCircleInfo,
    styles: 'border-deep-blue-lighten-15 bg-deep-blue-lighten-90',
    color: 'text-deep-blue',
  },
  warning: {
    icon: faTriangleExclamation,
    styles: 'border-yellow-darken-5 bg-yellow-lighten-70',
    color: 'text-yellow-darken-60',
  },
};
